import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InsuranceStateData } from "../models/insurance";

const initialState: InsuranceStateData[] = [];

const insuranceSlice = createSlice({
  name: 'insurance',
  initialState,
  reducers: {
    setInsurances(state, action: PayloadAction<InsuranceStateData[]>) {
      return action.payload;
    },
    addInsurance(state, action: PayloadAction<InsuranceStateData>) {
      state.push(action.payload);
      return state;
    },
    deleteInsuranceByDocId(state, action: PayloadAction<string>) {
      return state.filter(ins => ins.id !== action.payload);
    },
    deleteInsuranceByBillId(state, action: PayloadAction<string>) {
      return state.filter(ins => ins.billId !== action.payload);
    },
    resetInsurance() {
      return initialState;
    },
    updateInsurance(state, action: PayloadAction<InsuranceStateData>) {
      const index = state.findIndex(ins => ins.id === action.payload.id);
      if (index !== -1) {
        state[index] = action.payload;
      }
      return state;
    },
  },
});

export const { setInsurances, addInsurance, deleteInsuranceByDocId, deleteInsuranceByBillId, resetInsurance, updateInsurance } = insuranceSlice.actions;
export default insuranceSlice.reducer;
